import WaterCard from "./water_card/water_card.js.jsx";

const $ = require('jquery');
require('jquery.cookie');

export default class WaterList extends React.Component {
  constructor(props) {
    super(props);
    this._renderWaterCard = this._renderWaterCard.bind(this);
  }

  _renderWaterCard(water, index) {
    const props = {
      filter_params: this.props.filter_params,
      water_id: water.water_id,
      data: water,
      name: water.name,
      filters: this.props.filters,
      pictures: (water.pictures && water.pictures.length > 0) ? water.pictures : [],
      filter_alt_img: (water.pictures && water.pictures.length > 0) ? water.pictures[0].photo_description : '',
      default_photo: water.default_photo,
      characteristic: water.characteristic,
      count_variants: water.count_variants,
      seo_path: water.seo_path,
      short_description: water.short_description,
      water_url: water.water_url,
      active_status: water.active_status,
      active_post_page_status: water.active_post_page_status
    };

    const activeWatersCount = this.props.waters.filter(water => water.active_post_page_status === true).length;

    return (
      <div>
        {(index === activeWatersCount && index !== 0) && (
          <div className="card cards__separator">
            Возможно, Вам будет интересно:
          </div>
        )}
        <WaterCard {...props}/>
      </div>
    )
  }

  render() {
    let waters = this.props.waters.map(this._renderWaterCard);
    return (
      <div className="cards">
        {waters}
      </div>
    );
  }
}
